

export const REPORT_ROUTES = [{
    path: "vehicleListReport",
    name: "vehicleListReport",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/components/tables/VehicleListReport"),
},
{
    path: "vehicleDetailsReport",
    name: "vehicleDetailsReport",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/VehicleDetailsReport"),
},
{
    path: "vehiclealertReport",
    name: "vehiclealertReport",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/VehicleAlertReport"),
},
{
    path: "safetyDriverLeagueReport",
    name: "safetyDriverLeagueReport",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/SafetyDriverLeagueReport"),
},
    {
        path: "alertsSummary",
        name: "alertSummarytReport",
        component: () =>
            import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/AlertsSummary"),
    },
{
    path: "operatingCostSummary",
    name: "operatingCostSummary",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/OperatingCostSummary"),
},
{
    path: "totalCostTrend",
    name: "totalCostTrend",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/TotalCostTrend"),
},
{
    path: "utilizationSummary",
    name: "utilizationSummary",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/UtilizationSummary"),
},
{
    path: "statusChanges",
    name: "statusChanges",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/StatusChanges"),
},
{
    path: "statusSummary",
    name: "statusSummary",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/StatusSummary"),
},
{
    path: "vehicleAssignmentLog",
    name: "vehicleAssignmentLog",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/VehicleAssignmentLog"),
},
{
    path: "vehicleAssignmentSummary",
    name: "vehicleAssignmentSummary",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/VehicleAssignmentSummary"),
},
{
    path: "contactListReport",
    name: "contactListReport",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/components/tables/ContactListReport"),
},
{
    path: "issueReport",
    name: "issueReport",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/IssueReportLayout"),
},
    {
        path: "userActivityListReport",
        name: "userActivityListReport",
        component: () =>
            import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/UserActivityListReport"),
    },
{
    path: "contactRenewalReport",
    name: "contactRenewalReport",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/ContactRenewalLayout"),
},
{
    path: "vehicleBatteryStatus",
    name: "vehicleBatteryStatus",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/VehicleBatteryStatus.vue"),
},
{
    path: "inspectionSummary",
    name: "inspectionSummary",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/InspectionSummaryLayout"),
},
{
    path: "inspectionSubmissionList",
    name: "inspectionSubmissionList",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/InspectionSubmissionList"),
},
{
    path: "inspectionSubmissionSummary",
    name: "inspectionSubmissionSummary",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/InspectionSubmissionSummary"),
},
{
    path: "inspectionFailuresList",
    name: "inspectionFailuresList",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/InspectionFailuresList"),
},
{
    path: "serviceSummary",
    name: "serviceSummary",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/ServiceSummary"),
},

{
    path: "serviceHistorybyVehicle",
    name: "serviceHistorybyVehicle",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/ServiceHistorybyVehicle"),
},
{
    path: "serviceTaskSummary",
    name: "serviceTaskSummary",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/ServiceTaskSummary"),
},
{
    path: "serviceReminders",
    name: "serviceReminders",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/ServiceReminders"),
},
{
    path: "vehiclesWithoutService",
    name: "vehiclesWithoutService",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/VehiclesWithoutService"),
},
{
    path: "fuelSummary",
    name: "fuelSummary",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/FuelSummary"),
},
{
    path: "expenseSummary",
    name: "expenseSummary",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/ExpenseSummary.vue"),
},
{
    path: "fuelLevelSensor",
    name: "fuelLevelSensor",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/FuelLevelSensor.vue"),
},
{
    path: "fuelByMerchant",
    name: "fuelByMerchant",
    component: () =>
        import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/FuelByMerchant"),
},
    {
        path: "canbusVehicleStats",
        name: "canbusVehicleStats",
        component: () =>
            import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/CANBusVehicleStats"),
    },

];